import React from 'react';
import { ArrowRightIcon, BookOpenIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { ScreenContainer } from '../story/ScreenContainer';
import { ScreenHeading } from '../story/ScreenHeading';
import { ActionRow } from '../story/ActionRow';
import { Button } from '../story/Button';
import { echoLines, echoTitle } from '../../data/savanna';
export function EchoScreen() {
  const {
    dispatch
  } = useDemo();
  return <ScreenContainer width="narrow" data-id="element-156" data-mp="pa4e4z8onc9m">
      <ScreenHeading eyebrow="Echo fragment" data-id="element-157" data-mp="t9d4du4iks0f">{echoTitle}</ScreenHeading>
      <ul className="mt-8 flex flex-col" data-id="element-158" data-mp="tbfvkhhekr6q">
        {echoLines.map((line, index) => <li key={line} className="anim-enter border-b border-line py-4 font-display text-2xl text-forest last:border-0" style={{
        animationDelay: `${index * 50}ms`
      }} data-id="element-159" data-mp="fg418b75t2qc" data-mpi={index}>
            {line}
          </li>)}
      </ul>
      <p className="mt-6 flex items-start gap-3 rounded-2xl bg-sand p-5" data-id="element-160" data-mp="1cydv9nuybbuf">
        <BookOpenIcon size={20} className="mt-1 shrink-0 text-teal" aria-hidden="true" data-id="element-161" data-mp="5h2y9kmp78s4" />
        <span data-id="element-162" data-mp="1g9acr999tz8">
          Added to your Field Guide: <strong data-id="element-163" data-mp="1hkdqpysgzpt">Echo Fragment: The silence was not one thing.</strong>
        </span>
      </p>
      <ActionRow onBack={() => dispatch({
      type: 'BACK'
    })} data-id="element-164" data-mp="f85y6j3w5hpt">
        <Button onClick={() => dispatch({
        type: 'GO',
        screen: 'finish'
      })} iconAfter={<ArrowRightIcon size={18} aria-hidden="true" data-id="element-166" data-mp="p5bq1tkbxcr3" />} data-id="element-165" data-mp="agxl9d3cre7w">
          See the closing signal
        </Button>
      </ActionRow>
    </ScreenContainer>;
}